module.exports = __webpack_public_path__ + "img/icons-filter-blue.9ecf20f9.svg";